var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<button type=\"button\" class=\"btn btn-link\" uib-popover-template=\"layoutUrl\" aria-haspopup=\"true\" popover-placement=\"bottom\" popover-trigger=\"'outsideClick'\">\n<span class=\"fa fa-calendar-o\"></span>\n<span class=\"visible-xs\" translate=\"PUBLIC_BOOKING.POPOUT_EXPORT_BOOKING.SHORT_EXPORT_LBL\"></span>\n<span class=\"hidden-xs\" translate=\"PUBLIC_BOOKING.POPOUT_EXPORT_BOOKING.LONG_EXPORT_LBL\"></span>\n</button>\n";
var id1="core/booking-export/popout_export_booking.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/booking-export/popout_export_booking.html
// module id = 1110
// module chunks = 0